import React, { useEffect, useState } from "react";
import {
  Button,
  Collapse,
  Descriptions,
  Divider,
  Form,
  Input,
  notification,
  Select,
  Spin,
  Switch,
  Table,
  Tag,
  Typography,
} from "antd";
import { get, post } from "../../../api/axios";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router";
import { ArrowLeftOutlined } from "@ant-design/icons";
import ReactQuill from "react-quill";

const { Title } = Typography;
const { Panel } = Collapse;

const ChangeStatus = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [fromLoading, setFromLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [listingInfo, setListingInfo] = useState([]);
  const [changes, setChanges] = useState([]);

  const columnsForChanges = [
    { title: "Column Name", dataIndex: "column_name" },
    { title: "Old Value", dataIndex: "old_value" },
    { title: "New Value", dataIndex: "new_value" },
  ];

  useEffect(() => {
    get(`listings/${id}`).then((res) => {
      const { changes, ...rest } = res.data;
      const pendingChanges = changes.filter((item) => item.status == "pending");
      if (pendingChanges.length == 0) {
        navigate("/listings");
      } else {
        const changesArray = pendingChanges.map((item) =>
          Object.entries(item.original_values).map(([key, value]) => ({
            column_name: key,
            old_value: value,
            new_value: res.data[key],
          }))
        )
        .flat();
        setChanges(changesArray);
        const otherDataArray = Object.entries(rest).map(([key, value]) => ({
          key,
          value,
        }));
        setListingInfo([...otherDataArray]);
      }
      setFromLoading(true);
    });
  }, []);

  const onFinish = (values) => {
    setLoading(true);

    post(`listings/change-status/${id}`, values)
      .then((res) => {
        notification.success({ message: "Modified successfully" });
        setLoading(false);
        navigate("/listings");
      })
      .catch((err) => {
        notification.error({
          message: "Error!",
          description: err.response.data.message,
        });
        setLoading(false);
      });
  };

  return (
    <div>
      <Title level={2} className="text-main mb-2">
        <ArrowLeftOutlined onClick={() => navigate("/listings")} />
        Listings Change Status
      </Title>

      {fromLoading ? (
        <div className="row">
          <Collapse defaultActiveKey={["3"]}>
            <Panel header="Listing Info" key="1">
              {listingInfo.length > 0 && (
                <div className="row">
                  <Descriptions bordered colon className="p-2">
                    {listingInfo.map(
                      (item) =>
                        item.key != "images" && (
                          <Descriptions.Item label={item.key} key={item.key}>
                            {item.key == "is_active" ? (
                              <Tag
                                color={`${
                                  item.value == 1 ? "success" : "error"
                                }`}
                              >
                                {item.value == 1 ? "Active" : "Inactive"}
                              </Tag>
                            ) : item.key == "is_approved" ? (
                              <Tag
                                color={`${
                                  item.value == 1 ? "success" : "error"
                                }`}
                              >
                                {item.value == 1 ? "Approved" : "Rejected"}
                              </Tag>
                            ) : item.key == "is_furnished" ? (
                              <Tag
                                color={`${
                                  item.value == 1 ? "success" : "error"
                                }`}
                              >
                                {item.value == 1
                                  ? "Furnished"
                                  : "Not Furnished"}
                              </Tag>
                            ) : (
                              item.value
                            )}
                          </Descriptions.Item>
                        )
                    )}
                  </Descriptions>
                </div>
              )}
            </Panel>
            <Divider />
            <Panel header="History" key="2">
              <div className="row">
                <div className="w-100">
                  <Table
                    locale={{ emptyText: "There are no data" }}
                    loading={loading}
                    columns={columnsForChanges}
                    dataSource={changes}
                    size="small"
                    responsive
                    pagination={false}
                  />
                </div>
              </div>
            </Panel>
            <Divider />
            <Panel header="Change Status" key="3">
              <div className="row">
                <Form
                  className="wrapper-content"
                  onFinish={onFinish}
                  labelCol={{
                    span: 4,
                  }}
                  wrapperCol={{
                    span: 10,
                  }}
                  initialValues={{
                    status: "approved",
                    note: "",
                  }}
                  autoComplete="off"
                >
                  <div className="row">
                    <div className="col-lg-12">
                      <Form.Item label="Status" name="status">
                        <Select
                          placeholder="Select..."
                          style={{ width: "100%" }}
                          options={[
                            { value: "approved", label: "Approved" },
                            { value: "rejected", label: "Rejected" },
                          ]}
                        />
                      </Form.Item>
                    </div>
                    <div className="col-lg-12">
                      <Form.Item label="Note" name="note">
                        <ReactQuill theme="snow" />
                      </Form.Item>
                    </div>

                    <div className="col-lg-4 offset-lg-4">
                      <Form.Item
                        wrapperCol={{
                          offset: 1,
                          span: 16,
                        }}
                      >
                        <Button
                          loading={loading}
                          size="large"
                          block
                          type="primary"
                          htmlType="submit"
                        >
                          {loading ? "Updating..." : "Update"}
                        </Button>
                      </Form.Item>
                    </div>
                  </div>
                </Form>
              </div>
            </Panel>
          </Collapse>
        </div>
      ) : (
        <div className="text-center">
          <Spin size="large" />
        </div>
      )}
    </div>
  );
};

export default ChangeStatus;
